import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import config from 'constants/config'
import SearchHeader from 'components/Search/SearchHeader/SearchHeader'
import { isSearchEnabled } from 'lib/searchUtils'
import TrustIndicatorSection from 'home/components/TrustIndicatorSection/TrustIndicatorSection'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.eight};
`

const StyledTrustIndicatorSection = styled(TrustIndicatorSection)`
  padding-top: ${rem(20)};
  padding-bottom: ${rem(20)};
  
  ${mediaQueryUp.lg} {
    padding-top: ${rem(40)};
    padding-bottom: ${rem(40)};
  }
`

export function LEOnboardingBlock() {
  const { t } = useTranslation('common')

  return (
    <>
      {isSearchEnabled() && <SearchHeader
        title={t(config.searchFormSection.title)}
      />}
      <Container>
        <StyledTrustIndicatorSection />
      </Container>
    </>
  )
}

export default LEOnboardingBlock
